import { render, staticRenderFns } from "./Selectlivegoods.vue?vue&type=template&id=56ba05fc&scoped=true"
import script from "./Selectlivegoods.vue?vue&type=script&lang=js"
export * from "./Selectlivegoods.vue?vue&type=script&lang=js"
import style0 from "./Selectlivegoods.vue?vue&type=style&index=0&id=56ba05fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba05fc",
  null
  
)

export default component.exports